import type { ReactNode, FC } from 'react';
import c from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import s from './ContentBlock.scss';

interface Props {
  heading: ReactNode;
  content: ReactNode;
  className?: string;
}

const ContentBlock: FC<Props> = ({ heading, content, className }) => {
  return (
    <Section className={c(s['root'], className)}>
      {heading}
      {content}
    </Section>
  );
};
ContentBlock.displayName = 'ContentBlock';

export default ContentBlock;
